import request from './common/request'
import qs from 'qs'

import { SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL } from './urls'

async function list (params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${params.competitionId}/partner`,
    method: 'GET',
    params: params
  })
}

async function getPartnerInviteUrl (params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${params.competitionId}/partner/partnerInviteUrl`,
    method: 'GET',
    params: params
  })
}

async function getCompetitionInviteUrl (params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${params.competitionId}/partner/competitionIdInviteUrl`,
    method: 'GET',
    params: params
  })
}

async function changePartnerStatus (data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/partner/${data.partnerId}/status/${data.status}`,
    method: 'PUT'
  })
}

async function addPartner (data) {
  const { competitionId, ...body } = data || {}
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${competitionId}/partner/adminJoin`,
    method: 'POST',
    data: body
  })
}

export default {
  list,
  changePartnerStatus,
  getPartnerInviteUrl,
  getCompetitionInviteUrl,
  addPartner
}



// WEBPACK FOOTER //
// ./src/api/merchant-simbart-activity-competition-partner.js